export default function HeroArt() {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" width="100%" height="100%">
            <defs>
                <radialGradient id="pierogyGradient" cx="50%" cy="50%" r="70%">
                    <stop offset="0%" stop-color="#63D2FF"/>
                    <stop offset="45%" stop-color="#2B6CB0"/>
                    <stop offset="100%" stop-color="#123B6E"/>
                </radialGradient>

                <style>
                    .icon-stroke {
                        fill: none;
                        stroke: url(#pierogyGradient);
                        stroke-width: 4.5;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                    }
                </style>

                <path id="star"
                      d="M 150,0
                         C 116.225,-19.5 75,-90.9038 75,-129.9038
                         C 41.225,-110.4038 -41.225,-110.4038 -75,-129.9038
                         C -75,-90.9038 -116.225,-19.5 -150,0
                         C -116.225,19.5 -75,90.9038 -75,129.9038
                         C -41.225,110.4038 41.225,110.4038 75,129.9038
                         C 75,90.9038 116.225,19.5 150,0 Z" />
            </defs>

            <g transform="translate(175, 175)" class="icon-stroke">
                <use href="#star" />
                <use href="#star" transform="rotate(-8.6)" />
                <polygon points="86,0 43,-74.4782 -43,-74.4782 -86,0 -43,74.4782 43,74.4782" />
                <path d="M -150,0 L 150,0 M -75,-129.9038 L 75,129.9038 M 75,-129.9038 L -75,129.9038" />
            </g>
        </svg>

        <div class="hero__brand">
            <div class="hero__brand-title">
                DIOSCURI<br /> CENTRE
            </div>
            <div class="hero__brand-subtitle">
                Random Walks<br>
                in Geometry and Topology
            </div>
        </div>
    `;
}
